// Whiteboard - freehand canvas drawing with undo + PNG export.
import { el, btn, input, wrap, download } from "./ui.js";

export function whiteboard(root) {
	const s = wrap(root); s.classList.add("rv-wb");
	const canvas = el("canvas", "rv-wb-canvas");
	canvas.setAttribute("role", "img");
	canvas.setAttribute("aria-label", "Drawing area");
	const ctx = canvas.getContext("2d");
	const colorIn = input("color", { value: "#e9c46a" });
	colorIn.setAttribute("aria-label", "Pen colour");
	const sizeIn = input("range", { min: "1", max: "40", value: "4" });
	sizeIn.setAttribute("aria-label", "Pen size");
	let erasing = false, drawing = false, last = null;
	const undoStack = [];

	function fit() {
		const rect = canvas.getBoundingClientRect();
		const data = canvas.width ? ctx.getImageData(0, 0, canvas.width, canvas.height) : null;
		canvas.width = Math.max(300, rect.width | 0);
		canvas.height = Math.max(220, rect.height | 0);
		ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, canvas.width, canvas.height);
		if (data) ctx.putImageData(data, 0, 0);
	}
	function pos(e) { const r = canvas.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; }
	function snapshot() { try { undoStack.push(ctx.getImageData(0, 0, canvas.width, canvas.height)); if (undoStack.length > 30) undoStack.shift(); } catch (e) {} }

	canvas.style.touchAction = "none"; // drawing with a finger or stylus must not scroll the page
	canvas.addEventListener("pointerdown", (e) => { drawing = true; snapshot(); last = pos(e); canvas.setPointerCapture(e.pointerId); });
	canvas.addEventListener("pointermove", (e) => {
		if (!drawing) return;
		const p = pos(e);
		ctx.strokeStyle = erasing ? "#ffffff" : colorIn.value;
		ctx.lineWidth = erasing ? parseInt(sizeIn.value) * 3 : parseInt(sizeIn.value);
		ctx.lineCap = "round"; ctx.lineJoin = "round";
		ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
		last = p;
	});
	const stop = () => { drawing = false; };
	canvas.addEventListener("pointerup", stop);
	canvas.addEventListener("pointerleave", stop);
	canvas.addEventListener("pointercancel", stop);

	const penBtn = btn("Pen", () => { erasing = false; penBtn.classList.add("active"); eraseBtn.classList.remove("active"); }, "rv-chip active");
	const eraseBtn = btn("Eraser", () => { erasing = true; eraseBtn.classList.add("active"); penBtn.classList.remove("active"); }, "rv-chip");
	const undoBtn = btn("Undo", () => { const img = undoStack.pop(); if (img) ctx.putImageData(img, 0, 0); }, "rv-tbtn");
	const clearBtn = btn("Clear", () => { snapshot(); ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, canvas.width, canvas.height); }, "rv-tbtn");
	const saveBtn = btn("Save PNG", () => download("whiteboard.png", canvas.toDataURL("image/png")), "rv-tbtn rv-tbtn-accent");

	const bar = el("div", "rv-wb-bar");
	bar.append(penBtn, eraseBtn, colorIn, sizeIn, undoBtn, clearBtn, saveBtn);
	s.append(bar, canvas);
	requestAnimationFrame(fit);
	window.addEventListener("resize", fit);
}
